import type { FC } from "react";
import type { ButtonBasicProps } from "@/components/buttons/shared.ts";
import { ButtonIcon } from "@/components/buttons/ButtonIcon.tsx";
import { IconSend } from "@/icons/IconSend.tsx";

interface ButtonSubmitProps extends ButtonBasicProps {
  text?: string;
  disabled?: boolean;
}

export const ButtonSubmit: FC<ButtonSubmitProps> = ({
  text,
  onClick,
  disabled,
  tooltip,
  flare,
}) => {
  return (
    <ButtonIcon
      onClick={onClick}
      icon={<IconSend />}
      text={text ?? "Send"}
      backgroundColor={"#4353FF"}
      disabledBackgroundColor={"#445486"}
      disabledOverride={disabled}
      tooltip={tooltip}
      flare={flare}
    />
  );
};
